{
  "name": "@prisma/engines-version",
  "version": "6.13.0-35.361e86d0ea4987e9f53a565309b3eed797a6bcbd",
  "main": "index.js",
  "types": "index.d.ts",
  "license": "Apache-2.0",
  "author": "Tim Suchanek <suchanek@prisma.io>",
  "prisma": {
    "enginesVersion": "361e86d0ea4987e9f53a565309b3eed797a6bcbd"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/prisma/engines-wrapper.git",
    "directory": "packages/engines-version"
  },
  "devDependencies": {
    "@types/node": "18.19.76",
    "typescript": "4.9.5"
  },
  "files": [
    "index.js",
    "index.d.ts"
  ],
  "scripts": {
    "build": "tsc -d"
  }
}